import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';

import { BrightnessContrastConfigModule, NgZorroAntModule, PositionOutConfigModule } from 'vhobjects-service';
import { MaterialModule } from 'vhobjects-service';
import { PortalModule } from '@angular/cdk/portal';
import { DynamicModule } from 'ng-dynamic-component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { AtwBlockBlankConfig } from './blocks/block-blank/config/block-blank-config/block-blank-config.component';
import { AtwBlockHeaderConfig } from './blocks/block-header/config/block-header-config/block-header-config.component';
import { AtwBlockFooterConfig } from './blocks/block-footer/config/block-footer-config/block-footer-config.component';
import { AtwBlockChatboxConfig } from './blocks/block-chatboxs/config/block-chatbox-config/block-chatbox-config.component';
import { VhStringPercentPipeModule } from './vhstringpercent.pipe';
import { PositionInConfigModule } from 'vhobjects-service';
import { WidthHeightConfigModule } from 'vhobjects-service';
import { AnimationsConfigModule } from 'vhobjects-service';

import { BordersRadiusConfigModule } from 'vhobjects-service';
import { HideShowConfigModule } from 'vhobjects-service';
import { BackgroundImageConfigModule } from 'vhobjects-service';
import { BordersConfigModule } from 'vhobjects-service';
import { ShadowConfigModule } from 'vhobjects-service';

import { TranslateModule } from '@ngx-translate/core';
import { ChooseAnimationsConfigModule  } from 'vhobjects-service';
import { PaddingConfigModule } from 'vhobjects-service';
 

const componentMap = {
    AtwBlockBlankConfig: AtwBlockBlankConfig,
    AtwBlockHeaderConfig: AtwBlockHeaderConfig,
    AtwBlockFooterConfig: AtwBlockFooterConfig,
    AtwBlockChatboxConfig: AtwBlockChatboxConfig
};

let component = [
    AtwBlockBlankConfig,
    AtwBlockHeaderConfig,
    AtwBlockFooterConfig,
    AtwBlockChatboxConfig
];

@Pipe({ name: 'blockpipecomponent' })
export class BlockPipe implements PipeTransform {
    transform(value: string): any {
        if (componentMap[value]) {
            return componentMap[value];
        }
        throw new Error(`${componentMap[value]} component was not found`);
    }
}

@NgModule({
    declarations: [component, BlockPipe],
    entryComponents: [component],
    imports: [
        CommonModule,
        NgZorroAntModule,
        PortalModule,
        FormsModule,
        MaterialModule,
        CKEditorModule,
        ReactiveFormsModule,
        DynamicModule,
        NgbCarouselModule,
        ColorPickerModule,
        VhStringPercentPipeModule,
        PositionInConfigModule,
        PositionOutConfigModule,
        WidthHeightConfigModule,
        AnimationsConfigModule,
        ChooseAnimationsConfigModule,
        BordersRadiusConfigModule,
        HideShowConfigModule,
        BackgroundImageConfigModule,
        BordersConfigModule,
        ShadowConfigModule,
        TranslateModule,
        PaddingConfigModule,
        BrightnessContrastConfigModule

    ],
    exports: [component, BlockPipe]
})
export class BlockComponentModule { }
